import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import logo from '../assets/images/logo/agentbuzz200.png';

const styles = theme => ({
  root: {
    maxWidth: 650,
    margin: 'auto',
    display: 'flex',
    marginBottom: 10,
  },
  logo: {
    paddingTop: 10,
    maxWidth: 120,
  },
  flex: {
    flexGrow: 1,
  },
  buttonContainer: {
    paddingTop: 10,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

const HeaderLoggedOut = props => {
  const { classes, signin, signup } = props;
  return (
    <div className={classes.root}>
      <div className={classes.flex}>
        <img className={classes.logo} src={logo} alt="AgentBuzz Logo" />
      </div>
      <div className={classes.buttonContainer}>
        <Button className={classes.button} href="https://www.agentbuzz.com">
          Home
        </Button>
        <Button
          className={classes.button}
          href="https://www.agentbuzz.com/#pricing"
        >
          Pricing
        </Button>
        {signup && (
          <Button
            className={classes.button}
            href="https://www.agentbuzz.com/#pricing"
          >
            Sign Up
          </Button>
        )}
        {signin && (
          <Button className={classes.button} href="/signin">
            Sign In
          </Button>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(HeaderLoggedOut);



// WEBPACK FOOTER //
// ./src/components/HeaderLoggedOut.js